import React from "react";
import { DpatIndicatorSlugProvider } from "context/DpatIndicatorSlugContext";

/**
 * Card shell for one DPAT sub-indicator (e.g. CI 1.0 - 1.1) with clear scroll boundaries.
 * Code and thematic area come from `DpatIndicatorCmsIntro` (CMS), not this header.
 */
function DpatSubIndicatorSection({ code, title, children, className = "" }) {
  return (
    <DpatIndicatorSlugProvider slug={code}>
      <section
        className={`card my-6 scroll-mt-24 overflow-hidden p-0 shadow-sm ${className}`.trim()}
        data-dpat-indicator={code || undefined}
      >
        {title ? (
          <header className="border-b border-border bg-muted/30 px-4 py-3 md:px-5">
            <p className="text-sm text-muted-foreground">{title}</p>
          </header>
        ) : null}
        <div className="space-y-4 px-4 py-5 md:px-5 md:py-6">{children}</div>
      </section>
    </DpatIndicatorSlugProvider>
  );
}

export default DpatSubIndicatorSection;
